import { Fragment, useEffect, useState } from 'react';
import { Card } from '../../components/ui/card';
import api from '../../lib/api';
import { when } from './fmt';

export const MultiplierGrid = ({ tick }) => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState('');
  useEffect(() => { api.get('/trainer-targets/multiplier-grid').then(r => setD(r.data)); }, [tick]);
  if (!d) return null;
  return (
    <Card className="overflow-x-auto" data-testid="tt-multiplier-grid">
      <div className="px-4 pt-3 pb-1 text-sm font-bold text-slate-900">Multiplier by quarter</div>
      <p className="px-4 text-[11px] text-slate-500 mb-2">Highlighted = custom multiple for that trainer. Click a trainer to see each quarter's changes and reasons.</p>
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500">
          <tr><th className="text-left px-4 py-2">Trainer</th>{d.quarters.map(q => <th key={q.key} className="px-2 text-center">{q.label}<div className="font-normal normal-case text-slate-400">default {d.defaults[q.key]}×</div></th>)}</tr>
        </thead>
        <tbody>
          {d.rows.map(r => (
            <Fragment key={r.trainer_id}>
              <tr className="border-t border-slate-100 hover:bg-slate-50/50 cursor-pointer" onClick={() => setOpen(o => (o === r.trainer_id ? '' : r.trainer_id))} data-testid={`tt-grid-row-${r.trainer_id}`}>
                <td className="px-4 py-2 font-medium text-slate-900">{r.name}</td>
                {d.quarters.map(q => {
                  const c = r.cells[q.key];
                  return <td key={q.key} className="text-center px-2" data-testid={`tt-grid-${r.trainer_id}-${q.key}`}>
                    <span className={`inline-block px-2 py-0.5 rounded text-xs font-semibold ${c.overridden ? 'bg-violet-100 text-violet-700' : 'text-slate-600'}`}>{c.multiple}×</span>
                    {c.changes.length > 0 && <span className="text-[9px] text-slate-400 ml-1">{c.changes.length} chg</span>}
                  </td>;
                })}
              </tr>
              {open === r.trainer_id && (
                <tr className="bg-slate-50/60"><td colSpan={d.quarters.length + 1} className="px-4 py-3">
                  <div className="grid md:grid-cols-4 gap-3" data-testid={`tt-grid-changes-${r.trainer_id}`}>
                    {d.quarters.map(q => (
                      <div key={q.key}>
                        <div className="text-[11px] font-semibold text-slate-700 mb-1">{q.label}</div>
                        {r.cells[q.key].changes.length === 0 ? <div className="text-[11px] text-slate-400">No changes</div> : [...r.cells[q.key].changes].reverse().slice(0, 5).map(h => (
                          <div key={h.id} className="text-[11px] border-l-2 border-violet-200 pl-2 mb-1.5">
                            <div className="text-slate-700">{h.change}</div>
                            <div className="text-slate-400">{h.by} · {when(h.at)}{h.note ? ` · “${h.note}”` : ''}</div>
                          </div>
                        ))}
                        {r.cells[q.key].changes.length > 5 && <div className="text-[10px] text-slate-400">+{r.cells[q.key].changes.length - 5} older — see the change log below</div>}
                      </div>
                    ))}
                  </div>
                </td></tr>
              )}
            </Fragment>
          ))}
        </tbody>
      </table>
    </Card>
  );
};
